// 项目设置
const settings = {
  title: '集思学院教务系统',
  ip: '0.0.0.0',
  devServerPort: 9527,
  mockServerPort: 9527
}

export default settings
